import "./style.css";
import { mountShell } from "./ui/shell";
import { initCloudSync, onRemoteUpdate } from "./lib/storage";
import { initCosmetics } from "./lib/cosmetics";

// Apply the equipped palette + background before the first render (no color flash).
initCosmetics();

const app = document.getElementById("app");
if (app) {
  mountShell(app);
}

// Kick off cloud sync (no-op if Firebase isn't configured). When the first
// cloud snapshot merges in, re-render the current screen so progress shows up.
initCloudSync().catch((err) => console.warn("[Logika] cloud sync init failed:", err));

// Re-render on cross-device progress updates by re-dispatching the route.
// (Only remote updates fire this - local writes never disrupt the current screen.)
let pendingRemote = false;
// Deferred to a fresh task so the re-render never nests inside another handler
// (a synchronous hashchange dispatch mid-navigation would leak the half-built screen).
const refreshFromRemote = () => setTimeout(() => window.dispatchEvent(new HashChangeEvent("hashchange")), 0);
onRemoteUpdate(() => {
  // Don't yank the screen out from under an open modal (e.g. mid level-complete);
  // defer the refresh until the modal closes instead of dropping it. Only a
  // VISIBLE modal counts - one mid fade-out is already closing.
  if (document.querySelector(".modal-backdrop.show")) {
    pendingRemote = true;
    return;
  }
  refreshFromRemote();
});
window.addEventListener("logika:modal-closed", () => {
  if (pendingRemote) {
    pendingRemote = false;
    refreshFromRemote();
  }
});

// Register the service worker for offline/installable PWA (production only).
if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("./sw.js").catch((err) => console.warn("[Logika] SW registration failed:", err));
  });
}
